if (!customElements.get('nd-style-with')) {
  class NdStyleWith extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-sw-track]');
      this.rooms = this.querySelectorAll('[data-sw-room]').length;
      this.current = this.querySelector('[data-sw-current]');
      this.prev = this.querySelector('[data-sw-prev]');
      this.next = this.querySelector('[data-sw-next]');
      this.index = 0;
      if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1));
      if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1));
      this.go(0);
    }
    go(i) {
      this.index = Math.max(0, Math.min(this.rooms - 1, i));
      if (this.track) this.track.style.transform = `translateX(-${this.index * 100}%)`;
      if (this.current) this.current.textContent = this.index + 1;
      if (this.prev) this.prev.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index >= this.rooms - 1;
    }
  }
  customElements.define('nd-style-with', NdStyleWith);
}
